/* app/js/src/components/common/radioCollection/radioCollection.component.scss */
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.cursor-pointer {
  cursor: pointer;
}
ul {
  margin: 17px 0;
  width: 100%;
}
ul.horizontal {
  display: flex;
}
ul li {
  color: #879baf;
  font-size: 0.9em;
  margin: 11px 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
}
ul li i {
  border: 1px solid #879baf;
  height: 10px;
  min-height: 10px;
  width: 10px;
  min-width: 10px;
  border-radius: 50%;
  opacity: 0.5;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
ul li i span {
  display: block;
  background-color: #879baf;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  opacity: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
ul li label {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  margin-left: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
ul li:hover label {
  color: #232f3a;
}
ul li:hover i span {
  opacity: 0.5;
}
ul li.selected i {
  opacity: 1;
}
ul li.selected i span {
  opacity: 1;
}
ul li.selected label {
  color: #232f3a;
}
input {
  visibility: hidden;
}
/*# sourceMappingURL=radioCollection.component.css.map */
